import { Box, Field } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";
import { PasswordInput } from "../ui/password-input";

interface CustomPasswordInputProps {
  invalid?: boolean;
  required?: boolean;
  label?: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  placeholder?: string;
}

function CustomPasswordInput({
  invalid,
  required,
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  placeholder = "Password",
  ...props
}: CustomPasswordInputProps) {
  const colors = useThemeColors();
  return (
    <Field.Root invalid={invalid} required={required}>
      {label && <Field.Label>{label}</Field.Label>}
      <Box pos="relative" w="full">
        <PasswordInput
          borderColor={colors.border.input}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          fontSize="16px"
          {...props}
        />
      </Box>
      <Field.ErrorText>{error}</Field.ErrorText>
    </Field.Root>
  );
}

export default CustomPasswordInput;
